import { MaterialReactTable, MRT_ColumnDef, MRT_GroupingState, MRT_Row, MRT_SortingState, MRT_TableInstance } from "material-react-table";
import { Dispatch, ReactNode, SetStateAction, useEffect, useState } from "react";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { DANGER_COLOR, INFO_COLOR, WARNING_COLOR } from "../../_const/color.const";

export function StandardTable(params: {
    loading?: boolean,
    columns: MRT_ColumnDef<any>[],
    data: ITableData<any>,
    filter: IFilteringViewModel,
    setFilter: Dispatch<SetStateAction<any>>,
    grouping?: MRT_GroupingState,
    enableExpanding?: boolean,
    enableBottomToolbar?: boolean,
    renderDetailPanel?: (props: {
        row: MRT_Row<any>;
        table: MRT_TableInstance<any>;
    }) => ReactNode;
    isNested?: boolean;
}) {


    const [selectedRowId, setSelectedRowId] = useState(0);

    const [sorting, setSorting] = useState<MRT_SortingState>([{ id: params.filter.orderBy || "id", desc: params.filter.order === "desc" }]);
    const [pagination, setPagination] = useState({
        pageIndex: params.filter.pageIndex || 0,
        pageSize: params.filter.pageSize || 100,
    });

    const pageSizes = [10, 50, 100, 1000];

    useEffect(() => {

        if ((!sorting || !sorting.length) && (params.filter.sorting && params.filter.sorting.length)) {
            params.setFilter((prev: any) => ({ ...prev, order: "", orderBy: "" }))
        }

        if (sorting && sorting.length) {
            let _sorting = { order: sorting[0].desc ? "desc" : "asc", orderBy: sorting[0].id };
            if (_sorting.order !== params.filter.order || _sorting.orderBy !== params.filter.orderBy) {
                params.setFilter((prev: any) => {
                    return { ...prev, ..._sorting }
                })
            }
        }

    }, [sorting]);

    useEffect(() => {
        if (pagination.pageIndex !== params.filter.pageIndex || pagination.pageSize !== params.filter.pageSize) {
            params.setFilter((prev: any) => ({ ...prev, pageIndex: pagination.pageIndex, pageSize: pagination.pageSize }))
        }

    }, [pagination]);

    return <>
        <MaterialReactTable
            columns={params.columns}
            data={params.data.items || []}
            manualPagination
            manualSorting
            enableTopToolbar={false}
            enableExpanding={params.enableExpanding}
            rowCount={params.data.count || 10}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            enableMultiSort={false}
            enableBottomToolbar={params.enableBottomToolbar}
            enableGrouping={(params.grouping && !!params.grouping.length)}
            initialState={{
                grouping: params.grouping,
                expanded: {}
            }}
            maxMultiSortColCount={1}
            renderDetailPanel={params.renderDetailPanel}
            muiTableBodyRowProps={({ row }) => ({
                sx: {
                    ...(row.original.isActive || row.original.isCompleted && {
                        textDecoration: 'line-through',   // 🎯 CROSSOVER the entire row
                        color: 'gray',                    // Optional: dim color
                    }),
                    ...(row.original.nextActionDate && { // highlight the row based on Next Action Date in Client Follow ups 
                        backgroundColor:
                            new Date(row.original.nextActionDate) <= new Date() ? DANGER_COLOR //Red if we are past or equal to todays date
                                : new Date(row.original.nextActionDate) > new Date() ? WARNING_COLOR //Yellow if we are past the Next action date
                                    : undefined, //No colour if null
                    }),
                    ...(row.original.ticketQuery && { // highlight the row based on Ticket Query
                        backgroundColor:
                            row.original.ticketQuery === "Yes" ? INFO_COLOR //Blue if there is an unresolved query on the ticket
                                : undefined, //No colour if null
                    }),
                    ...((params.isNested) && { //Background of nested table is coloured
                        backgroundColor: "#ffe58f !important", //Light Yellow
                    }),
                },
            })}
            state={{
                pagination,
                sorting,
                isLoading: params.loading || false,
            }}
            muiPaginationProps={{
                rowsPerPageOptions: pageSizes, // ✅ this is where you define page size options
            }}
            paginationDisplayMode="default" // ✅ shows page numbers and page size selector
        />
    </>;
}

